<template>
  <b-modal
    id="compose-mail"
    :visible="shallShowEmailComposeModal"
    title="Compose Email"
    :modal-class="{ 'modal-sticky': !isFullScreen }"
    footer-class="removed"
    body-class="p-0"
    :size="isFullScreen ? 'xl' : 'lg'"
    :centered="isFullScreen"
    no-fade
    :hide-backdrop="!isFullScreen"
    :no-close-on-backdrop="isFullScreen"
    :no-close-on-esc="isFullScreen"
    static
    @change="(val) => $emit('update:shall-show-email-compose-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <h5 class="modal-title">كتابة {{ !isReply ? "مراسلة" : "رد" }}</h5>
      <div class="modal-actions">
        <feather-icon
          @click="isFullScreen = !isFullScreen"
          :icon="!isFullScreen ? 'Maximize2Icon' : 'Minimize2Icon'"
          class="ml-1 cursor-pointer"
        />
        <feather-icon
          icon="XIcon"
          class="ml-1 cursor-pointer"
          @click="discardEmail"
        />
      </div>
    </template>

    <!-- Modal: Body -->
    <b-form>
      <!-- Field: To -->
      <div v-if="!isReply && isMinistry" class="compose-mail-form-field">
        <label for="email-to" class="form-label">إلى : </label>
        <form-autocomplete
          ep="v2/ministry/search-engine/ngos"
          v-model="composeData.ngo"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          class="flex-grow-1 email-to-selector"
          :getOptionLabel="(x) => x.name_ar"
          :reduce="(x) => x.id"
          input-id="email-to"
          id="ngos-autocomplete"
        >
          <template #option="{ logo, name_ar }">
            <b-avatar size="sm" :src="logo" />
            <span class="ml-50"> {{ name_ar }}</span>
          </template>

          <template #selected-option="{ logo, name_ar }">
            <b-avatar size="sm" class="border border-white" :src="logo" />
            <span class="ml-50"> {{ name_ar }}</span>
          </template>
        </form-autocomplete>
        <!-- <span class="cursor-pointer" @click="showCcField = !showCcField"
          >Cc</span
        >
        <span class="ml-1 cursor-pointer" @click="showBccField = !showBccField"
          >Bcc</span
        > -->
      </div>

      <!-- Field: Cc (Hidden Initially) -->
      <!-- <div v-show="showCcField" class="compose-mail-form-field">
        <label for="email-cc">CC: </label>
        <v-select
          v-model="composeData.cc"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          multiple
          label="name"
          class="flex-grow-1 email-cc-selector"
          :close-on-select="false"
          :options="emailToOptions"
          input-id="email-cc"
        >
          <template #option="{ avatar, name }">
            <b-avatar size="sm" :src="avatar" />
            <span class="ml-50"> {{ name }}</span>
          </template>

          <template #selected-option="{ avatar, name }">
            <b-avatar size="sm" class="border border-white" :src="avatar" />
            <span class="ml-50"> {{ name }}</span>
          </template>
        </v-select>
      </div> -->

      <!-- Field: Bcc (Hidden Initially) -->
      <!-- <div v-show="showBccField" class="compose-mail-form-field">
        <label for="email-bcc">Bcc </label>
        <v-select
          v-model="composeData.bcc"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          multiple
          label="name"
          class="flex-grow-1 email-bcc-selector"
          :close-on-select="false"
          :options="emailToOptions"
          input-id="email-bcc"
        >
          <template #option="{ avatar, name }">
            <b-avatar size="sm" :src="avatar" />
            <span class="ml-50"> {{ name }}</span>
          </template>

          <template #selected-option="{ avatar, name }">
            <b-avatar size="sm" class="border border-white" :src="avatar" />
            <span class="ml-50"> {{ name }}</span>
          </template>
        </v-select>
      </div> -->

      <!-- Field: Subject -->
      <div v-if="!isReply" class="compose-mail-form-field">
        <label for="email-subject">الموضوع: </label>
        <b-form-input id="email-subject" v-model="composeData.title" />
      </div>

      <!-- Field: Message - Quill Editor -->
      <div class="message-editor scroll-cont">
        <div style="height: 250px; overflow: auto">
          <quill-editor
            id="quil-content"
            v-model="composeData.content"
            :options="editorOption"
          />
        </div>

        <div id="quill-toolbar" class="d-flex border-bottom-0">
          <!-- Add a bold button -->
          <button class="ql-bold" />
          <button class="ql-italic" />
          <button class="ql-underline" />
          <!-- <button class="ql-link" /> -->
        </div>
        <div class="attachments-list">
          <b-alert
            dir="ltr"
            v-for="(file, i) in attachmentsList"
            :key="`${file.name}${file.lastModified}${file.size}`"
            show
            variant="secondary"
            dismissible
            class="m-50 p-50 w-50"
            @dismissed="attachmentsList.splice(i, 1)"
          >
            <div>
              <a target="_blank" :href="getUrl(file)">
                <span class="alert-body">
                  {{ file.name }}
                </span>
              </a>
              ({{ file.size / 1000 }} KB)
            </div>
          </b-alert>
        </div>
      </div>

      <!-- Footer -->
      <div class="d-flex align-items-center p-50 justify-content-between">
        <!-- Footer: Left Content -->
        <div>
          <!-- <b-dropdown
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            split
            text="Send"
            variant="primary"
            right
            @click="sendEmail"
          >
            <b-dropdown-item> Schedule Send </b-dropdown-item>
          </b-dropdown> -->
          <loader-btn
            variant="primary"
            icon="SendIcon"
            label="إرسال"
            loadingLabel="جارٍ الإرسال "
            @click="sendEmail"
            :loading="sending"
          />
          <feather-icon
            icon="PaperclipIcon"
            size="17"
            class="ml-2 cursor-pointer"
            @click="$refs.attachments.click()"
          />
          <input
            multiple
            type="file"
            name="attachments"
            class="removed"
            ref="attachments"
            id="email-attachments"
            @input="handleAttachments"
          />
        </div>

        <!-- Footer: Right Content -->
        <!-- <div>
          <b-dropdown variant="link" no-caret toggle-class="p-0" right>
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="17"
                class="text-body"
              />
            </template>

            <b-dropdown-item> Add Label </b-dropdown-item>

            <b-dropdown-item> Plain Text Mode </b-dropdown-item>

            <b-dropdown-divider />

            <b-dropdown-item> Print </b-dropdown-item>
            <b-dropdown-item> Check Spelling </b-dropdown-item>
          </b-dropdown>

          <feather-icon
            icon="Trash2Icon"
            size="17"
            class="ml-75 cursor-pointer"
            @click="discardEmail"
          />
        </div> -->
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BDropdown,
  BAlert,
  BDropdownItem,
  BForm,
  BFormInput,
  BAvatar,
  BDropdownDivider,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { computed, ref } from "@vue/composition-api";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
import LoaderBtn from "@/components/loader-btn.vue";
import FormAutocomplete from "@/components/form-autocomplete/index.vue";
import store from "@/store";
import authHelpers from "@/utils/auth-helpers";

export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BDropdown,
    BAlert,
    BDropdownItem,
    BForm,
    BFormInput,
    BAvatar,
    BDropdownDivider,
    // 3rd Party
    quillEditor,
    vSelect,
    LoaderBtn,
    FormAutocomplete,
  },
  model: {
    prop: "shallShowEmailComposeModal",
    event: "update:shall-show-email-compose-modal",
  },
  props: {
    messageId: Number,
    isReply: Boolean,
    shallShowEmailComposeModal: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const composeData = ref({});
    const showCcField = ref(false);
    const showBccField = ref(false);
    const isFullScreen = ref(false);
    const attachmentsList = ref([]);
    const isMinistry = ref(false);
    isMinistry.value = authHelpers.isUserMinistry();
    const editorOption = {
      modules: {
        toolbar: "#quill-toolbar",
      },
      placeholder: "الرسالة",
    };

    /* eslint-enable global-require */

    const sendEmail = async () => {
      var toSend = new FormData();
      for (const key in composeData.value) {
        if (Object.hasOwnProperty.call(composeData.value, key)) {
          const element = composeData.value[key];
          toSend.append(key, element);
        }
      }
      if (attachmentsList.value.length > 0) {
        for (var i = 0; i < attachmentsList.value.length; i++) {
          toSend.append("attachments[]", attachmentsList.value[i]);
        }
      }
      if (props.isReply && props.messageId) {
        toSend.append("message_id", props.messageId);
        await store.dispatch("Messaging/sendReply", toSend).then(() => {
          emit("replySent");
        });
      } else
        await store.dispatch("Messaging/sendEmail", toSend).then(() => {
          emit("emailSent");
        });
      emit("update:shall-show-email-compose-modal", false);
      composeData.value = {};
      attachmentsList.value = [];
    };

    const getUrl = (obj) => {
      return URL.createObjectURL(obj);
    };

    const sending = computed(() => store.getters["Messaging/sending"]);

    const discardEmail = () => {
      isFullScreen.value = false;
      attachmentsList.value = [];
      composeData.value = {};
      emit("update:shall-show-email-compose-modal", false);
    };
    const handleAttachments = (e) => {
      attachmentsList.value.push(...e.target.files);
    };
    return {
      composeData,
      editorOption,
      showCcField,
      showBccField,
      getUrl,
      // Email actions
      isFullScreen,
      sendEmail,
      discardEmail,
      handleAttachments,
      attachmentsList,
      sending,
      isMinistry,
    };
  },
};
</script>

<style lang="scss">
/* Element | http://localhost:8080/messaging/sent */

/* Element | http://localhost:8080/messaging/sent */
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
.scroll-cont {
  overflow: auto;
  height: 300px;
}
form ::v-deep {
  // Mail To vue-select style
  .v-select {
    .vs__dropdown-toggle {
      border: 0;
      box-shadow: none;
    }
    .vs__open-indicator {
      display: none;
    }
  }
  .alert.alert-dismissible .close {
    /* padding: 0.5rem 1rem 0.5rem 1rem; */
    padding: 0.1rem 1rem !important;
  }
  // Quill Editor Style
  .quill-editor {
    .ql-tooltip {
      z-index: 9999;
    }
    .ql-container.ql-snow {
      border-bottom: 0 !important;
    }
  }
}
</style>
